// Types
import { FocContributionFactor } from '@molecules/index';

/**
 * Transforms an array of FocContributionFactors into an array of tick values.
 *
 * The function takes an array of FocContributionFactor objects and calculates
 * the sum of negative and positive contribution factors separately. It then
 * returns an array with two elements, where the first element is the sum of
 * negative contribution factors and the second element is the sum of positive
 * contribution factors.
 *
 * @param {FocContributionFactor[]} focContributionFactors - An array of FocContributionFactor objects.
 * @returns {[number, number]} An array of two numbers representing the sum of negative and positive contribution factors.
 */
export function transformContributionsIntoTickValues(focContributionFactors: FocContributionFactor[]) {
  let negativeTick = 0;
  let positiveTick = 0;

  const positiveContributionFactors: FocContributionFactor[] = [];
  const negativeContributionFactors: FocContributionFactor[] = [];

  for (const item of focContributionFactors) {
    if (item.value <= 0) {
      negativeTick += item.value;
      negativeContributionFactors.push(item);
    } else {
      positiveTick += item.value;
      positiveContributionFactors.push(item);
    }
  }

  return { tickValues: [negativeTick, positiveTick], negativeContributionFactors, positiveContributionFactors };
}
